import type { FaireProductEntity } from "../../entity_types/product";

export const p_anhrm56q5g: FaireProductEntity = {
  token: "p_anhrm56q5g",
  type: "product",
  name: "Round Lab Grown Diamond Excellent Cut VVS2 IGI Certified",
  brandToken: "b_6nzzuc6eex",
  brandName: "Fine Diamond",
  imageUrl:
    "https://cdn.faire.com/fastly/993857d94b630f94d8be0f77b45637c1178b9a25b0bafbec2fee179f49239476.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/eaee56cf00cd5c37fd8e04a6651eaac5ca76040ff6c567d7e45f108fe1f78df9.jpeg",
    "https://cdn.faire.com/fastly/ba9622c6f9a18382c57509d3fa1233e8702376334c06027e869497880ea80fb1.jpeg",
    "https://cdn.faire.com/fastly/829e4ff576ff02bcea4b6e54b815d700db680f899f7a3dea6e352493ea9a2b24.jpeg",
    "https://cdn.faire.com/fastly/2121c5adab553a6764f85b33d6026353c37d1b07bb8d27afc1d01e7bcf0c9007.jpeg",
    "https://cdn.faire.com/fastly/c6fd666d76c5eb9c270ce609ae2c658b5238057f5a84344a96d1c6559a6ede40.jpeg",
    "https://cdn.faire.com/fastly/4fcb092a065da1c2a3631d4720768257ecb32775283b3875e6bd3ea8871a974a.jpeg",
    "https://cdn.faire.com/fastly/e44c9a6ecffd046a29b8c5ac843d38b1fa72f6b3ba3a4ae89a55d86ff265f601.jpeg",
  ],
  priceDollars: 580.6,
  description:
    "This IGI-certified loose lab-grown diamond from Fine Diamond comes in a round shape. It is available in D, E, and F color grades and has a VVS2 clarity rating. The diamond is offered in sizes ranging from 1 to 5 carats. \n\n\nProduct Type Color Carat Options Clarity \nLoose Lab-Grown Diamond D, E, F 1 to 5 Carats VVS1 \n\n\nAs a conflict-free and eco-conscious gemstone, this lab-created diamond is the perfect choice for those who care about sustainability without compromising on beauty. Ethically grown and responsibly sourced, it reflects modern values while maintaining all the natural allure of a traditional mined diamond. Ideal for crafting solitaire rings, pendants, and earrings, this gem offers complete design freedom with a clear conscience.\n\nWhether you're celebrating a special occasion, shopping for April birthstone gifts, or simply designing a timeless piece of jewelry, this premium lab-grown diamond represents strength, purity, and enduring elegance. Explore our complete collection of lab-made diamonds, loose gemstones, and custom jewelry stones to create meaningful pieces that reflect your values. At Fine Diamond, we’re committed to delivering excellence with every stone.\n",
  tags: [],
  msrpDollars: 2903.01,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:45:22.400Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
